var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Menu'),_c('carrusel'),_c('quienes'),_c('filosofia'),_c('inspeccion'),_c('asesoria'),_c('administracion'),_c('galeria'),_c('FooterPage')],1)}
var staticRenderFns = []

export { render, staticRenderFns }